var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.75,
  clipPath: "url(#wallet_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.164 5.037c0-1.077.876-1.953 1.953-1.953h.676l-.204-.567a.78.78 0 0 0-1.002-.47l-6.83 2.486a.78.78 0 0 0-.467 1.003l.361.985h5.513z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.117 4.256a.78.78 0 0 0-.781.78v1.485h6.836V5.037a.78.78 0 0 0-.781-.781zM20.242 17.79h-2.734a2.933 2.933 0 0 1-2.93-2.929 2.933 2.933 0 0 1 2.93-2.93h2.734V9.256c0-.863-.7-1.563-1.562-1.563H3.563C2.7 7.693 2 8.393 2 9.256v11.182C2 21.3 2.7 22 3.563 22H18.68c.863 0 1.562-.7 1.562-1.562z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.414 13.103h-3.906a1.76 1.76 0 0 0-1.758 1.758c0 .97.789 1.758 1.758 1.758h3.906a.587.587 0 0 0 .586-.586v-2.344a.587.587 0 0 0-.586-.586"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wallet_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgWallet;